// extracted by mini-css-extract-plugin
export default {"container":"CollectionPointBilling_container__cbZNO"};